import { createContext } from "react";

// Create the questionnaire context
export const QuestionnaireContext = createContext();
